import Client from '../axios-client';

const resource = '/system-application/applications';

export default {
  getSystemApplicationsFprGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  getSystemApplication(systemApplicationId) {
    return Client.get(`${resource}/${systemApplicationId}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(payload, systemApplicationId) {
    return Client.put(`${resource}/${systemApplicationId}`, payload);
  },
  remove(systemApplicationId, version) {
    return Client.delete(`${resource}/${systemApplicationId}?version=${version}`);
  },
  sendForApproval(systemApplicationId, version) {
    return Client.put(`${resource}/${systemApplicationId}/send-for-approval?version=${version}`);
  },
  approve(systemApplicationId, version) {
    return Client.put(`${resource}/${systemApplicationId}/approve?version=${version}`);
  },
  reject(systemApplicationId, payload) {
    return Client.put(`${resource}/${systemApplicationId}/reject`, payload);
  },

  // getUrlForAddAttachment(systemApplicationId) {
  //   return Client.defaults.baseURL + `${resource}/${systemApplicationId}/attachment`;
  // },
  // addAttachment: function(payload, id) {
  //   return Client.post(`${resource}/${id}/attachment`, payload,
  //     {
  //       headers: { 'Content-Type': 'multipart/form-data' }
  //     }
  //   );
  // },
  // removeAttachment(systemApplicationId, attachment, version) {
  //   return Client.delete(`${resource}/${systemApplicationId}/attachment/${attachment}?version=${version}`);
  // },
  // getAttachment(systemApplicationId, attachmentId) {
  //   return Client.get(`${resource}/${systemApplicationId}/attachment/${attachmentId}`,
  //     {
  //       responseType: 'blob',
  //     }
  //   )
  // },
  // downloadAttachment(systemApplicationId, attachmentId) {
  //   return Client.get(`${resource}/${systemApplicationId}/attachment/${attachmentId}/download`,
  //     {
  //       responseType: 'blob',
  //     }
  //   )
  // },
};
